<template>
  <!-- Impact and probability for a simple rating, or for each of C, I and A for a CIA rating (US 9370).
       v-model: { impact, probability } or { confidentiality: { impact, probability }, integrity: …, availability: … } -->
  <div class="rk-form" :qid="qid">
    <template v-if="method === 'cia_risk'">
      <div class="rk-cia rk-cia--head"><span></span><span>{{ $t('risk_tab.impact') }}</span><span>{{ $t('risk_tab.probability') }}</span><span>{{ $t('risk_tab.risk') }}</span></div>
      <div v-for="key in cia" :key="key" class="rk-cia">
        <span class="rk-cia__lab"><b :class="'is-' + key">{{ $t('systems_overview.criticality.' + key).slice(0, 1) }}</b>{{ $t('systems_overview.criticality.' + key) }}</span>
        <RiskLevelPicker :value="part(key).impact" :levels="scale.impact" kind="impact" :disabled="disabled" :qid="qid + '-' + key + '-impact'" @input="set(key, 'impact', $event)"></RiskLevelPicker>
        <RiskLevelPicker :value="part(key).probability" :levels="scale.probability" kind="probability" :disabled="disabled" :qid="qid + '-' + key + '-probability'" @input="set(key, 'probability', $event)"></RiskLevelPicker>
        <RiskScore small :value="partScore(key)" :band="band(scale, partScore(key))"></RiskScore>
      </div>
    </template>
    <template v-else>
      <div class="rk-simple">
        <div class="rk-simple__pickers">
          <div class="rk-upd__row">
            <span class="rk-upd__lab">{{ $t('risk_tab.impact') }}<small>{{ $t('risk_tab.impact_hint') }}</small></span>
            <RiskLevelPicker :value="value.impact" :levels="scale.impact" kind="impact" :disabled="disabled" :qid="qid + '-impact'" @input="emit({ impact: $event })"></RiskLevelPicker>
          </div>
          <div class="rk-upd__row">
            <span class="rk-upd__lab">{{ $t('risk_tab.probability') }}<small>{{ $t('risk_tab.probability_hint') }}</small></span>
            <RiskLevelPicker :value="value.probability" :levels="scale.probability" kind="probability" :disabled="disabled" :qid="qid + '-probability'" @input="emit({ probability: $event })"></RiskLevelPicker>
          </div>
        </div>
        <RiskMatrix v-if="matrix"
                    class="rk-simple__matrix"
                    :scale="scale"
                    :picked="value.impact && value.probability ? value : null"
                    :pickable="!disabled"
                    @pick="emit($event)"></RiskMatrix>
      </div>
    </template>
  </div>
</template>

<script>
  import RiskLevelPicker from '@/components/risk/RiskLevelPicker.vue';
  import RiskMatrix from '@/components/risk/RiskMatrix.vue';
  import RiskScore from '@/components/risk/RiskScore.vue';
  import {band, score, CIA} from '@/components/risk/riskScale.js';

  export default {
    name: 'RiskRatingForm',
    components: {
      RiskLevelPicker,
      RiskMatrix,
      RiskScore
    },
    props: {
      value: { type: Object, required: true },
      scale: { type: Object, required: true },
      method: { type: String, required: true },
      disabled: { type: Boolean, default: false },
      // A matrix to click next to the pickers (simple ratings)
      matrix: { type: Boolean, default: false },
      qid: { type: String, default: 'risk-rating' }
    },
    data: function() {
      return {
        cia: CIA
      }
    },
    methods: {
      band: band,
      part(key) {
        return this.value[key] || {};
      },
      partScore(key) {
        return score(this.scale, this.part(key).impact, this.part(key).probability);
      },
      set(key, field, level) {
        let part = Object.assign({}, this.part(key), { [field]: level });
        this.$emit('input', Object.assign({}, this.value, { [key]: part }));
      },
      emit(change) {
        this.$emit('input', Object.assign({}, this.value, change));
      }
    }
  }
</script>
